module.exports = __webpack_public_path__ + "static/media/deudenum.ad12527b.ogg";